import { storageManager } from './storage-manager'

const ACTIVE_PROFILE_HEADER = 'x-pulsify-profile'

export const activeProfileStorageKey = (businessId: string) => `active_profile:${businessId}`

/** Names the active profile on every request, so credits are read and spent from its own plan. */
export function activeProfileHeaders(): Record<string, string> {
  const businessId = storageManager.getAdminViewingBusinessId() ?? storageManager.getBusinessId()
  if (!businessId) return {}
  const profileId = storageManager.get<string>(activeProfileStorageKey(businessId))
  return profileId ? { [ACTIVE_PROFILE_HEADER]: profileId } : {}
}
